// Explicitly applied to legacy action elements whose tag is required by existing styles.
// Native buttons should be used for new controls.
export const action = {
    bind (el) {
        el._actionAttributes = ['role', 'tabindex', 'aria-hidden'].map(name => ({ name, value: el.getAttribute(name) }))
        el.setAttribute('role', 'button')
        if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0')
        el.removeAttribute('aria-hidden')
        el._actionKeydown = function (event) {
            if (event.target !== el || event.repeat) return
            if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
                event.preventDefault()
                if (el.getAttribute('aria-disabled') !== 'true') el.click()
            }
        }
        el.addEventListener('keydown', el._actionKeydown)
    },
    inserted (el) {
        let parent = el.parentElement
        while (parent) {
            if (parent.classList.contains('slick-slide') && parent.getAttribute('aria-hidden') === 'true') {
                el._toneSlideTab = { value: el.getAttribute('tabindex') }
                el.setAttribute('tabindex', '-1')
                break
            }
            parent = parent.parentElement
        }
    },
    unbind (el) {
        el.removeEventListener('keydown', el._actionKeydown)
        ;(el._actionAttributes || []).forEach(attribute => {
            if (attribute.value === null) el.removeAttribute(attribute.name)
            else el.setAttribute(attribute.name, attribute.value)
        })
        delete el._actionAttributes
        delete el._actionKeydown
    }
}

export function visible (el) {
    return !!(el && el.getClientRects().length && window.getComputedStyle(el).visibility !== 'hidden')
}

function disableSharing (el, binding) {
    el._sharingDisabled = !!binding.value
    Array.prototype.forEach.call(el.querySelectorAll('button[data-link]'), button => {
        button.disabled = el._sharingDisabled
    })
}

// Preserve private-video restrictions when native sharing buttons gain keyboard support.
export const sharingDisabled = {
    bind (el, binding) {
        disableSharing(el, binding)
        el._blockSharing = event => {
            if (el._sharingDisabled) {
                event.preventDefault()
                event.stopImmediatePropagation()
            }
        }
        el.addEventListener('click', el._blockSharing, true)
    },
    componentUpdated: disableSharing,
    unbind (el) {
        el.removeEventListener('click', el._blockSharing, true)
        disableSharing(el, { value: false })
        delete el._blockSharing
    }
}

export function focusable (root) {
    return Array.prototype.filter.call(root.querySelectorAll('a[href], button, input, select, textarea, iframe, [tabindex], [contenteditable="true"]'), el => {
        return !el.disabled && el.tabIndex >= 0 && el.getAttribute('aria-hidden') !== 'true' && visible(el)
    })
}



// WEBPACK FOOTER //
// ./src/accessibility/controls.js